import "@/features/risk-assessment/pages/risk-assessment.scss";

import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";

import { Typography } from "../../../../components/Elements";

export interface CustomCellProps {
  value?: string | number;
  children?: React.ReactNode;
  dataTestID?: string;
  width?: number;
  onClick?: () => void;
  className?: string;
  extraCellContentClassNames?: string;
  allowClicks?: boolean;
}

function CustomCell({
  children,
  value,
  className,
  width,
  onClick,
  extraCellContentClassNames,
  dataTestID,
  allowClicks,
}: CustomCellProps) {
  const classess = classNames("cell-content", {
    // @ts-expect-error TS(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
    [extraCellContentClassNames]: extraCellContentClassNames,
  });
  const mainClassNames = classNames(
    "cell input-cell read-only table-cell-width",
    {
      // @ts-expect-error TS(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
      [className]: className,
      "pointer-events-none": !allowClicks,
    },
  );
  return (
    <li
      style={{ maxWidth: width }}
      className={mainClassNames}
      data-testid={dataTestID}
      onClick={onClick}
    >
      <div
        style={{ width }}
        className={classess}
        data-testid={`${dataTestID}-input`}
      >
        {!children && (
          <Typography label={value} size="sm" color="generalMidnightDark" />
        )}
        {children}
      </div>
    </li>
  );
}

export default observer(CustomCell);
